export const getChatTimeLeft = (lastInteractionAt) => {
    if (!lastInteractionAt) {
        return {
            expired: true,
            text: 'Expired'
        };
    }

    const last = new Date(lastInteractionAt).getTime();
    const expiresAt = last + 24 * 60 * 60 * 1000;
    const remaining = expiresAt - Date.now();

    if (remaining <= 0) {
        return {
            expired: true,
            text: 'Expired'
        };
    }

    const hours = Math.floor(remaining / (1000 * 60 * 60));
    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));

    return {
        expired: false,
        text: `${hours}h ${minutes}m left`
    };
};
